import { get, post } from './api_base';

// get the current user's coapplicants
export const coappGetUserCoapplicants = async (coapp_owner_user) => {
  const path = `coapplicants/${coapp_owner_user}`;

  try {
    const getRequest = await get(path);
    return getRequest;
  } catch(err) {
    console.log('Error getting /coapplicants: ', err);
    return err;
  }
}

// save a user's coapplicants
export const coappSaveFields = async (fieldValues) => {
  const path = 'coapplicants';
  const body = fieldValues;

  try {
    const postRequest = await post(path, body);
    return postRequest;
  } catch(err) {
    console.log('Error posting to /coapplicants: ', err);
    return err;
  }
};

// get a coapplicant full group that contains current user
export const coappGetGroup = async (coapp_owner_user) => {
  const path = `coapplicants/group/${coapp_owner_user}`;

  try {
    const getRequest = await get(path);
    return getRequest;
  } catch(err) {
    console.log('Error getting /coapplicants/group: ', err);
    return err;
  }
};

// remove a coapplicant from a user's coapplicants list
export const coappRemove = async (coapplicants_owner_user, coapplicant_remove) => {
  const path = 'coapplicants/remove';
  const body = { coapplicants_owner_user, coapplicant_remove };

  try {
    const postRequest = await post(path, body);
    return postRequest;
  } catch(err) {
    console.log('Error posting to /coapplicants/remove: ', err);
    return err;
  }
};

// accept a coapplicant
export const coappAccept = async (coapplicants_owner_user, coapplicant_accept) => {
  const path = 'coapplicants/accept';
  const body = { coapplicants_owner_user, coapplicant_accept };

  try {
    const postRequest = await post(path, body);
    return postRequest;
  } catch(err) {
    console.log('Error posting to /coapplicants/accept: ', err);
    return err;
  }
};

// decline a coapplicant
export const coappDecline = async (coapplicants_owner_user, coapplicant_accept) => {
  const path = 'coapplicants/decline';
  const body = { coapplicants_owner_user, coapplicant_accept };

  try {
    const postRequest = await post(path, body);
    return postRequest;
  } catch(err) {
    console.log('Error posting to /coapplicants/decline: ', err);
    return err;
  }
};